import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getInvoices (filter) {
    return Http.get({
      url: `invoices${filter}`
    })
  },
  getInvoice (invoiceId) {
    return Http.get({
      url: `invoices/${invoiceId}`
    })
  },
  getInvoiceCreateFormForCustomer (customerId) {
    return Http.get({
      url: `customers/${customerId}/invoices/form`
    })
  },
  getInvoiceCreateFormForCase (caseId) {
    return Http.get({
      url: `cases/${caseId}/invoices/form`
    })
  },
  setupArticlesListFormForCase (caseId) {
    return Http.get({
      url: `cases/${caseId}/articles/list-form`
    })
  },
  getArticlesListEditForm (invoiceId) {
    return Http.get({
      url: `invoices/${invoiceId}/articles/form`
    })
  },
  setupArticleAddForm () {
    return Http.get({
      url: `articles/form`
    })
  },
  setupArticleRowForm (articleNumber) {
    return Http.get({
      url: `articles/${articleNumber}/form`
    })
  },
  setupInvoiceForm (invoiceId) {
    return Http.get({
      url: `invoices/${invoiceId}/form`
    })
  },
  postInvoiceCreateForm (caseId, formData) {
    return Http.post({
      url: `cases/${caseId}/invoices/form`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  postInvoiceCreateFormForCustomer (customerId, formData) {
    return Http.post({
      url: `customers/${customerId}/invoices/form`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  putInvoiceEditForm (invoiceId, formData) {
    return Http.put({
      url: `invoices/${invoiceId}/form`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  putInvoiceArticleEditForm (invoiceId, formData, caseIds) {
    let data = Transform.createMultipartFormData(formData)
    if (caseIds) {
      data.append('case_ids', JSON.stringify(caseIds))
    }
    return Http.put({
      url: `invoices/${invoiceId}/articles/form`,
      data: data
    })
  },
  postConfirmInvoice (invoiceId) {
    return Http.post({
      url: `invoices/${invoiceId}/confirm`
    })
  },
  postCancelInvoice (invoiceId) {
    return Http.post({
      url: `invoices/${invoiceId}/cancel`
    })
  }
}
